"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _LH55DG7Mcjs = require('./LH55DG7M.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/composite/composite-group.tsx
var TagName = "div";
var useCompositeGroup = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useCompositeGroup2({ store, ...props }) {
    props = _LH55DG7Mcjs.useGroup.call(void 0, props);
    return props;
  }
);
var CompositeGroup = _PTOCUU2Dcjs.forwardRef.call(void 0, function CompositeGroup2(props) {
  const htmlProps = useCompositeGroup(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useCompositeGroup = useCompositeGroup; exports.CompositeGroup = CompositeGroup;
